export default __webpack_public_path__ + "static/flag-pt-0c70351a9ec94815d52b4e75b9271f62.svg";